import type {
  BillPaymentMethod,
  BillStatus,
  WorkOrderCategory,
  WorkOrderPriority,
  WorkOrderStatus,
} from '@myrentalmate/api-client';

type ChipColor = 'default' | 'success' | 'warning' | 'error' | 'info';

export const STATUS: Record<WorkOrderStatus, { label: string; color: ChipColor }> = {
  new: { label: 'New', color: 'warning' },
  assigned: { label: 'Assigned', color: 'info' },
  scheduled: { label: 'Scheduled', color: 'info' },
  in_progress: { label: 'In progress', color: 'info' },
  completed: { label: 'Completed', color: 'success' },
  canceled: { label: 'Canceled', color: 'default' },
};

export const PRIORITY: Record<WorkOrderPriority, { label: string; color: ChipColor }> = {
  low: { label: 'Low', color: 'default' },
  normal: { label: 'Normal', color: 'default' },
  high: { label: 'High', color: 'warning' },
  emergency: { label: 'Emergency', color: 'error' },
};

export const CATEGORY: Record<WorkOrderCategory, string> = {
  plumbing: 'Plumbing',
  electrical: 'Electrical',
  hvac: 'Heating and cooling',
  appliance: 'Appliance',
  pest: 'Pests',
  locks: 'Locks and keys',
  grounds: 'Grounds',
  general: 'Something else',
};

export const BILL_STATUS: Record<BillStatus, { label: string; color: ChipColor }> = {
  unpaid: { label: 'Unpaid', color: 'warning' },
  paid: { label: 'Paid', color: 'success' },
  void: { label: 'Void', color: 'default' },
};

export const BILL_METHOD: Record<BillPaymentMethod, string> = {
  check: 'Check',
  ach: 'Bank transfer',
  card: 'Card',
  cash: 'Cash',
  other: 'Other',
};

/** Options for a select, from one of the label tables above. */
export function optionsOf<K extends string>(table: Record<K, string | { label: string }>) {
  return (Object.keys(table) as K[]).map((value) => {
    const entry = table[value] as string | { label: string };
    return { value: value as string, label: typeof entry === 'string' ? entry : entry.label };
  });
}
